import React, { memo } from 'react';
import PropTypes from 'prop-types';

interface CardlessEMIProps {
  title?: string;
  description?: string;
}

const CardlessEMI = ({ title, description }: CardlessEMIProps) => {
  if (!title && !description) return null;

  return (
    <div className="flex items-start space-x-4">
      <div className="shrink-0">
        <svg
          width="20"
          height="20"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Insert your SVG paths here */}
          <path
            d="M10.8452 13.4882C10.5326 13.1756 10.1087 13 9.66667 13C9.22464 13 8.80072 13.1756 8.48816 13.4882C8.17559 13.8007 8 14.2246 8 14.6667C8 15.1087 8.17559 15.5326 8.48816 15.8452C8.80072 16.1577 9.22464 16.3333 9.66667 16.3333C10.1087 16.3333 10.5326 16.1577 10.8452 15.8452C11.1577 15.5326 11.3333 15.1087 11.3333 14.6667C11.3333 14.2246 11.1577 13.8007 10.8452 13.4882Z"
            fill="black"
          />
          <path
            d="M10.8452 18.8215C10.5326 18.5089 10.1087 18.3333 9.66667 18.3333C9.22464 18.3333 8.80072 18.5089 8.48816 18.8215C8.17559 19.1341 8 19.558 8 20C8 20.442 8.17559 20.866 8.48816 21.1785C8.80072 21.4911 9.22464 21.6667 9.66667 21.6667C10.1087 21.6667 10.5326 21.4911 10.8452 21.1785C11.1577 20.866 11.3333 20.442 11.3333 20C11.3333 19.558 11.1577 19.1341 10.8452 18.8215Z"
            fill="black"
          />
          <path
            d="M16.1785 13.4882C15.866 13.1756 15.442 13 15 13C14.558 13 14.1341 13.1756 13.8215 13.4882C13.5089 13.8007 13.3333 14.2246 13.3333 14.6667C13.3333 15.1087 13.5089 15.5326 13.8215 15.8452C14.1341 16.1577 14.558 16.3333 15 16.3333C15.442 16.3333 15.866 16.1577 16.1785 15.8452C16.4911 15.5326 16.6667 15.1087 16.6667 14.6667C16.6667 14.2246 16.4911 13.8007 16.1785 13.4882Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.8284 5.17157C27.5786 5.92172 28 6.93913 28 8V15.6798C27.3963 15.1794 26.7243 14.7587 26 14.4335V11.3333H6V24C6 24.5304 6.21071 25.0391 6.58579 25.4142C6.96086 25.7893 7.46957 26 8 26H14.4335C14.7587 26.7243 15.1795 27.3963 15.6798 28H8C6.93913 28 5.92172 27.5786 5.17157 26.8284C4.42143 26.0783 4 25.0609 4 24V8C4 6.93913 4.42143 5.92172 5.17157 5.17157C5.92172 4.42143 6.93913 4 8 4H24C25.0609 4 26.0783 4.42143 26.8284 5.17157ZM24 6H8C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8V9.33333H26V8C26 7.46957 25.7893 6.96086 25.4142 6.58579C25.0391 6.21071 24.5304 6 24 6Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.42 29.67C26.4241 29.67 29.67 26.4241 29.67 22.42C29.67 18.4159 26.4241 15.17 22.42 15.17C18.416 15.17 15.17 18.4159 15.17 22.42C15.17 26.4241 18.416 29.67 22.42 29.67ZM19.1551 18.9038C19.2544 19.003 19.389 19.0588 19.5294 19.0588H25.3529C25.4934 19.0588 25.628 19.003 25.7273 18.9038C25.8266 18.8045 25.8824 18.6698 25.8824 18.5294C25.8824 18.389 25.8266 18.2543 25.7273 18.1551C25.628 18.0558 25.4934 18 25.3529 18H19.5294C19.389 18 19.2544 18.0558 19.1551 18.1551C19.0558 18.2543 19 18.389 19 18.5294C19 18.6698 19.0558 18.8045 19.1551 18.9038Z"
            fill="black"
          />
          {/* More path data could go here if needed */}
        </svg>
      </div>
      <div>
        {title && (
          <h3 className="text-base font-semibold text-black">{title}</h3>
        )}
        {description && (
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        )}
      </div>
    </div>
  );
};

CardlessEMI.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

CardlessEMI.defaultProps = {
  title: '',
  description: '',
};

export default memo(CardlessEMI);
